import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  // Box,
  // Typography,
  // IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import * as services from "../../services/saleng";
import React from "react";
// import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";

const ProductFormDialog = ({ open, onClose, onSuccess, initialData }) => {
  const isEdit = Boolean(initialData);

  const [id, setId] = useState(null);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [title, setTitle] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [code, setCode] = useState("");
  // const [dragActive, setDragActive] = useState(false);

  const resetForm = () => {
    setImage(null);
    setPreview(null);
    setTitle("");
    setCategoryId("");
    setSubCategoryId("");
    setSubCategories([]);
    setPrice(0);
    setDescription("");
    setCode("");
  };

  // const handleImageFile = (file) => {
  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setImage(reader.result);
  //     setPreview(URL.createObjectURL(file));
  //   };
  //   reader.readAsDataURL(file);
  // };

  // const handleImageChange = (e) => {
  //   const file = e.target.files?.[0];
  //   if (file) handleImageFile(file);
  // };

  // const handleDrop = useCallback((e) => {
  //   e.preventDefault();
  //   setDragActive(false);
  //   const file = e.dataTransfer.files?.[0];
  //   if (file) handleImageFile(file);
  // }, []);

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  //   setDragActive(true);
  // };

  // const handleDragLeave = () => {
  //   setDragActive(false);
  // };

  // const handleRemoveImage = () => {
  //   setImage(null);
  //   setPreview(null);
  // };

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    setCategoryId(selectedId);
    const selected = categories.find((cat) => cat.id === Number(selectedId));
    setSubCategories(selected?.subCategories || []);
    setSubCategoryId("");
  };

  const handleSubmit = async (next) => {
    try {
      const trimmedTitle = title.trim();
      const normalizedTitle = trimmedTitle.toLowerCase();
      const currentProductId = initialData?.id ?? null;

      const existingProductsRes = await services.getProducts();
      const existingProducts = existingProductsRes?.data?.data ?? [];
      const hasDuplicateTitle = existingProducts.some((product) => {
        const sameTitle =
          String(product.title ?? "").trim().toLowerCase() === normalizedTitle;
        const sameProduct = currentProductId
          ? Number(product.id) === Number(currentProductId)
          : false;

        return sameTitle && !sameProduct;
      });

      if (hasDuplicateTitle) {
        const confirmResult = await Swal.fire({
          icon: "warning",
          title: "ชื่อสินค้าซ้ำ",
          text: "ชื่อสินค้านี้มีอยู่แล้ว ต้องการบันทึกต่อหรือไม่",
          showCancelButton: true,
          confirmButtonText: "บันทึกต่อ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            container: "my-swal",
          },
        });

        if (!confirmResult.isConfirmed) {
          return;
        }
      }

      const payload = {
        code: code?.trim() || undefined,
        title: trimmedTitle,
        description,
        categoryId: Number(categoryId),
        subCategoryId: Number(subCategoryId),
        price: Number(price),
        image,
      };

      if (isEdit) {
        await services.updateProduct(payload, id);
      } else {
        await services.createProduct(payload);
      }

      Swal.fire({
        icon: "success",
        title: isEdit ? "แก้ไขสินค้าเรียบร้อย" : "เพิ่มสินค้าสำเร็จ",
        text: isEdit
          ? "ข้อมูลสินค้าได้รับการอัปเดตแล้ว"
          : "สินค้าถูกเพิ่มเรียบร้อยแล้ว",
        customClass: {
          container: "my-swal",
        },
      }).then(() => {
        onSuccess();
        if (next) {
          setImage(null);
          setPreview(null);
          setTitle("");
          setPrice(0);
          setDescription("");
        } else {
          resetForm();
          onClose();
        }
      });
    } catch (err) {
      console.error("Product save failed:", err);
      const responseData = err?.response?.data;
      const errorMessage =
        typeof responseData === "string"
          ? responseData
          : responseData?.error || responseData?.message || err.message;

      Swal.fire({
        icon: "error",
        title: "เกิดข้อผิดพลาด",
        text: errorMessage || "ไม่สามารถบันทึกสินค้าได้ กรุณาลองใหม่",
        customClass: {
          container: "my-swal",
        },
      });
    }
  };

  const handleClose = async () => {
    resetForm();
    onClose();
  };

  useEffect(() => {
    services.getCategories().then((res) => {
      setCategories(res.data.data);
    });
  }, []);

  useEffect(() => {
    const selected = categories.find((cat) => cat.id === Number(categoryId));
    setSubCategories(selected?.subCategories || []);
    setSubCategoryId(initialData?.subCategoryId || "");
  }, [categoryId, categories, initialData?.subCategoryId]);

  useEffect(() => {
    if (!initialData) return;
    setTitle(initialData.title);
    setCategoryId(initialData.categoryId);
    setSubCategoryId(initialData.subCategoryId);
    setPrice(initialData.price);
    setDescription(initialData.description);
    setImage(initialData.image || null);
    setPreview(initialData.image || null);
    setId(initialData.id || null);
    setCode(initialData.code || "");
  }, [initialData]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        {isEdit ? "แก้ไขรายการสินค้า" : "เพิ่มรายการสินค้า"}
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        {/* <Box
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          sx={{
            border: `2px dashed ${dragActive ? "#4caf50" : "#ccc"}`,
            borderRadius: 2,
            padding: 2,
            textAlign: "center",
            backgroundColor: dragActive ? "#f1fff1" : "#fafafa",
            cursor: "pointer",
            mb: 1,
          }}
          onClick={() => document.getElementById("uploadInput").click()}
        >
          <Typography variant="body2" color="textSecondary">
            ลากไฟล์รูปภาพมาวาง หรือคลิกเพื่ออัปโหลด (รองรับไฟล์ .jpg .png)
          </Typography>
          {preview && (
            <Box mt={2} sx={{ position: "relative", display: "inline-block" }}>
              <img
                src={preview}
                alt="preview"
                style={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  borderRadius: 8,
                  border: "1px solid #ddd",
                }}
              />
              <IconButton
                onClick={handleRemoveImage}
                size="small"
                sx={{
                  position: "absolute",
                  top: -8,
                  right: -8,
                  backgroundColor: "#fff",
                  boxShadow: 1,
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
          <input
            type="file"
            accept="image/*"
            id="uploadInput"
            hidden
            onChange={handleImageChange}
          />
        </Box> */}

        <TextField
          label="ชื่อสินค้า"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          helperText="กรอกชื่อสินค้าที่จะแสดงในหน้าร้าน เช่น เหล็กเส้น 6 มม."
          sx={{ mt: 1 }}
        />
        <TextField
          label="รหัสสินค้า"
          fullWidth
          value={code}
          onChange={(e) => setCode(e.target.value)}
          helperText="ใส่รหัสสินค้า เช่น P001"
        />
        <TextField
          select
          label="หมวดหมู่"
          fullWidth
          value={
            categories.some((cat) => cat.id === Number(categoryId))
              ? categoryId
              : ""
          }
          onChange={handleCategoryChange}
          helperText="เลือกหมวดหมู่ เช่น เหล็ก, ไม้, อุปกรณ์ก่อสร้าง"
        >
          {categories.map((cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="หมวดหมู่ย่อย"
          fullWidth
          value={
            subCategories.some((sub) => sub.id === Number(subCategoryId))
              ? subCategoryId
              : ""
          }
          onChange={(e) => setSubCategoryId(e.target.value)}
          helperText="เลือกหมวดหมู่ย่อย เช่น เหล็กเส้น, เหล็กกล่อง ฯลฯ"
        >
          {subCategories.map((sub) => (
            <MenuItem key={sub.id} value={sub.id}>
              {sub.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="ราคาสินค้า"
          fullWidth
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value) || 0}
          helperText="ระบุราคาสินค้า หน่วยเป็นบาท เช่น 100.00"
          onFocus={(e) => e.target.select()}
        />
        <TextField
          label="คำอธิบายสินค้า"
          fullWidth
          multiline
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          helperText="ระบุข้อมูลเพิ่มเติม เช่น ขนาด, ความหนา, สี, หรือการใช้งาน"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ยกเลิก</Button>
        <Button
          onClick={() => handleSubmit(false)}
          variant="contained"
          color="success"
        >
          {isEdit ? "บันทึกการแก้ไข" : "บันทึก"}
        </Button>
        {!isEdit && (
          <Button
            onClick={() => handleSubmit(true)}
            variant="contained"
            color="success"
          >
            บันทึกและไปต่อ
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ProductFormDialog;
